// extracted by mini-css-extract-plugin
export default {"size":"40px","image":"Gf7054c","placeholder":"G3a1865"};